module.exports = __webpack_public_path__ + "img/logo1.bcea5fec.png";